// extracted by mini-css-extract-plugin
export var active = "_hz-2";
export var recordingDot = "_hz-1";
export var recordingIndicator = "_hz-0";